<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <TableComp
      :data="{
        title: 'Proveedores',
        buttons: [{ text: 'Nuevo Proveedor', action: openModal }],
        headers: [
          'id',
          'Nombre/Razón Social',
          'Alias',
          'RFC',
          'Calle/#',
          'Colonia/CP',
          'Municipio',
          'Crédito',
          'Plazo',
          'Importe',
          'Saldo Restante',
          'Opciones',
        ],
        visibleColumnsMobile: [1, 2, 3, 9, 11],
        ocultar: [0, 10],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <ModalUpdateComp
      v-if="isModalUpdate"
      :title="'Actualizar Proveedor'"
      :isOpen="isModalUpdate"
      :selectedData="selectedRow"
      :formFields="formFields"
      @update:selectedData="updateRowData"
      @close="closeModal"
      @updateData="updateProvider"
    />

    <TableComp
      :data="{
        title: 'Vendedores',
        headers: [
          'id',
          'Empresa',
          'Colaborador',
          'Correo',
          'Telefono',
          'Opciones',
        ],
        ocultar: [0],
      }"
      :rows="rowsSellers"
      :options="optionsSellers"
      @option-click="handleOptionActionSellers"
    />

    <ModalUpdateComp
      v-if="isModalUpdateSellers"
      :title="'Actualizar Vendedor'"
      :isOpen="isModalUpdateSellers"
      :selectedData="selectedRow"
      :formFields="formFieldsSellers"
      @update:selectedData="updateRowData"
      @close="closeModal"
      @updateData="updateSellers"
    />

    <Modal
      v-if="isModalOpen"
      :isOpen="isModalOpen"
      :title="'Agregar Proveedor'"
      :fields="formFields"
      :submitButtonText="'Guardar Proveedor'"
      @close="closeModal"
      v-model="formData"
      @submit="dataForm"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeModal"
      @confirm="deleteProvider"
    />

    <DeleteComp
      v-if="isDeleteSellerOpen"
      :isOpen="isDeleteSellerOpen"
      :deleteMessage="deleteMessage"
      @close="closeModal"
      @confirm="deleteSeller"
    />

    <Modal
      v-if="addSellers"
      :isOpen="addSellers"
      :title="'Agregar Vendedor'"
      :fields="formFieldsSellers"
      :submitButtonText="'Agregar'"
      @close="closeModal"
      v-model="formData"
      @submit="NewSellers"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import Modal from "@/components/ModalComp.vue";
import ModalUpdateComp from "@/components/ModalUpdateComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    TableComp,
    Modal,
    DeleteComp,
    ModalUpdateComp,
    SpinnerComp,
  },
  data() {
    return {
      isModalOpen: false,
      isDeleteOpen: false,
      isDeleteSellerOpen: false,
      addSellers: false,
      isModalUpdate: false,
      isModalUpdateSellers: false,
      loading: false,
      isSubmitting: false,
      rows: [],
      formFields: [
        {
          label: "Nombre o Razón Social",
          model: "nombreP",
          placeholder: "Nombre o Razón Social",
        },
        {
          label: "Alias o Nommbre Corto",
          model: "alias",
          placeholder: "Alias o nombre corto",
        },
        { label: "RFC", model: "rfcP", placeholder: "Ingrese RFC" },
        {
          label: "Calle y Número",
          model: "calleP",
          placeholder: "Ingrese Calle y Número",
        },
        {
          label: "Colonia y CP",
          model: "coloniaP",
          placeholder: "Ingrese Colonia y CP",
        },
        {
          label: "Municipio",
          model: "municipioP",
          placeholder: "Ingrese Municipio",
        },
        {
          label: "Credito",
          model: "creditoP",
          type: "select",
          options: [
            { label: "No", value: "no" },
            { label: "Si", value: "si" },
          ],
        },
        {
          label: "Plazo",
          model: "plazoP",
          type: "select",
          options: [
            { label: "15 dias", value: 15 },
            { label: "30 dias", value: 30 },
            { label: "45 dias", value: 45 },
            { label: "60 dias", value: 60 },
          ],
        },
        {
          label: "Importe",
          model: "importeP",
          type: "number",
          placeholder: "Importe",
        },
        {
          label: "Saldo Restante",
          model: "saldoRestanteP",
          type: "number",
          placeholder: "Saldo Restante",
        },
      ],
      formFieldsSellers: [
        {
          label: "Nombre",
          model: "nombreV",
          placeholder: "Ingrese su Nombre",
        },
        {
          label: "Correo",
          model: "correoV",
          placeholder: " Ingrese su  Correo",
        },
        {
          label: "Teleono",
          model: "telefonoV",
          placeholder: " Ingrese su telefono",
        },
      ],
      options: [
        {
          icon: "material-symbols-outlined edit",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
        {
          icon: "material-symbols-outlined person_add",
          action: "add",
          color: "bg-green-500",
        },
      ],
      rowsSellers: [],
      optionsSellers: [
        {
          icon: "material-symbols-outlined edit",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.addSellers = false;
      this.isModalUpdate = false;
      this.isModalUpdateSellers = false;
      this.isDeleteOpen = false;
      this.isDeleteSellerOpen = false;
    },
    handleOptionAction(action, row) {
      const actions = {
        edit: () => {
          this.selectedRow = { ...row };
          this.isModalUpdate = true;
          this.id = row.idP;
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${row.nombreP}?`;
          this.isDeleteOpen = true;
          this.id = row.idP;
        },
        add: () => {
          this.idProvedor = row.idP;
          this.addSellers = true;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    handleOptionActionSellers(action, rowSellers) {
      const actions = {
        edit: () => {
          console.log("Prueba de datos: ", { ...rowSellers });
          this.selectedRow = { ...rowSellers };
          this.isModalUpdateSellers = true;
          this.id = rowSellers.idV;
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${rowSellers.nombreV} de la empresa ${rowSellers.empresa}?`;
          this.isDeleteSellerOpen = true;
          this.id = rowSellers.idV;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    getProv() {
      this.loading = true;
      this.$axios
        .get("/getPrv")
        .then((response) => {
          this.rows = response.data.proveedores.map((item) => ({
            idP: item.idP,
            nombreP: item.nombreP,
            alias: item.alias,
            rfcP: item.rfcP,
            calleP: item.calleP,
            coloniaP: item.coloniaP,
            municipioP: item.municipioP,
            creditoP: item.creditoP,
            plazoP: item.plazoP,
            importeP: item.importeP,
            saldoRestanteP: item.saldoRestanteP,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVen() {
      this.$axios
        .get("/getVen")
        .then((response) => {
          this.rowsSellers = response.data.vendedores.map((item) => ({
            idV: item.idV,
            empresa: item.proveedor,
            nombreV: item.nombreV,
            correoV: item.correoV,
            telefonoV: item.telefonoV,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    dataForm(formData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .post("/registerPrv", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getProv();
          this.getVen();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    NewSellers(formData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      const CollaboratorData = {
        idProvedor: this.idProvedor,
        nombreV: formData.nombreV,
        telefonoV: formData.telefonoV,
        correoV: formData.correoV,
      };
      this.$axios
        .post("/registerVen", CollaboratorData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getProv();
          this.getVen();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    deleteProvider() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .delete(`/deletePrv/${this.id}`)
        .then((response) => {
          this.closeModal();
          alert(response.data.message);
          this.getProv();
          this.getVen();
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.message);
          }
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    deleteSeller() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .delete(`/deleteVen/${this.id}`)
        .then((response) => {
          this.closeModal();
          alert(response.data.message);
          this.getProv();
          this.getVen();
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.message);
          }
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    updateProvider(updateData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .put(`/updatePrv/${this.id}`, updateData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getProv();
          this.getVen();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    updateSellers(updateData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .put(`/updateVen/${this.id}`, updateData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getProv();
          this.getVen();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  mounted() {
    this.getProv();
    this.getVen();
  },
};
</script>
